<!-- 
Contents of the NOTICES tab of the provider page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :arrived-from-listing="arrivedFromListing"
      :breadcrumbs="breadcrumbs"
      :title="title"
      :subtitle="subtitle"
      user-guide-topic="listing-providers"
      user-guide-section="notices"
      module="providers"
      nav-url="/providers/:id/notices"
    />
    <tabs :provider-id="providerId" :incomplete-contacts="incompleteContacts">
      <our-search-button 
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search notices"
        flat
        show-all
        @changed="$refs.notices.refresh()"
      />
      <our-saved-searches-menu
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="notices" 
        color="primary"
        flat
        @selected="$refs.notices.refresh()"
      />
      <notice-listing 
        ref="notices" 
        :provider-id="providerId" 
        default-no-data-text="This provider does not have any notices yet."
        embedded
      />
    </tabs>
  </div>
</template>

<script>
import _ from "underscore";
import providerMixins from "./mixins";
import Tabs from "./Tabs.vue";
import NoticeListing from "@/components/notices/NoticeListing.vue";
import * as mutation from "@/store/notices/mutation-types";
import { getSearchFilters } from "@/store/notices/helpers";

export default {
  name: "ProviderNotices",
  components: { NoticeListing, Tabs },
  mixins: [providerMixins],
  data() {
    return {
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA
    };
  },
  computed: {
    criteria() {
      return this.$store.state.notices.listing.criteria;
    },
    searchFilters() {
      return _(getSearchFilters()).filter(f => f.value != "providerName" && f.value != "providerCode");
    }
  }
};
</script>
